export default __webpack_public_path__ + "static/media/emr.679d5614.svg";